<template>
	<div>
	<div class="row">
		<div class="col-12">
		    <div class="section-title" >ADD NEW COURSE</div>
		</div>
	</div>
	<div id="add-course-section" class="row">
	



        <div class="col-12 col-xl-10">
		    <div class="row">
	            <!-- show course info -->
	            <div class="col-auto flex-fill" >
	            	
		            <div class="row">
			            <div class="col-12">
				            <div class="input-content">
				            	<input class="input-course-title" placeholder="Course title here..." v-model="course.data.title" v-validate="'required'" name="name"/>
				            	<span class="input-error-msg">{{ errors.first('name') }}</span>
				            </div>

			            </div><!--col-->
		            </div><!--row-->

				<!-- New Agencies -->
				<label class="mb-2 h6 green">AGENCIES</label>

				<div class="row">
					<div class="col-4">
						<v-select
							v-model="selected_organization"
							class="green bg-gray v-select-no-height"
							:options="organizations"
							track-by="id"
							label="name"
							@input="message_selected_organization = ''"
							searchable
							multiple
						></v-select>
					</div>
				</div>



		         <div class="row">
			            <div class="col-12">
			            	<!--
				            <div class="input-content">
				            	<input class="input-course-title" placeholder="Duration (hours) i.e 12" 
				            			v-model="course.data.duration" v-validate="'required|numeric'" name="course_duration"/>
				            	<span class="input-error-msg">{{ errors.first('course_duration') }}</span>
				            </div>
							-->

			            </div><!--col-->
		            </div><!--row-->
		            <div class="row mt-5">
			            <div class="col-12 col-lg-8">
				            <div class="row">
								<b-col sm="10">
									<label class="mw-80 green">
										<strong>Description</strong>
									</label>
								<textarea class="form-control" v-model="course.data.description"
								
								name="description"
								 ></textarea>
								
								</b-col>
				            </div>	
							<div class="row mt-2">
								
								<b-col sm="10">
									<label class="mw-80 green">
										<strong>Notes</strong>
									</label>
								<textarea class="form-control" v-model="course.data.notes"
								
								name="notes"
								></textarea>
								 <span class="input-error-msg">{{ errors.first('notes') }}</span>
								</b-col>
								
							</div>
							<div class="row mt-2">
							
								<b-col sm="10">
									<label class="mw-80 green">
										<strong>Personalized Certification Text</strong>
									</label>
								<textarea class="form-control" v-model="course.data.certificate_text"
								
								name="certificationText"
								></textarea>
								 <span class="input-error-msg">{{ errors.first('certificationText') }}</span>
								</b-col>
								
								
								
							</div>
							<div class="row mt-2">
								<b-col class="" sm="10">
								<input class="line_holder-2 pointer" type="checkbox"  v-model="course.data.in_class">

								<label class="mw-80 green">
										<strong>In Class Program</strong>
								</label>


								</b-col>
							</div>
							<div class="row mt-2">
								<b-col class="" sm="10">
									<input class="line_holder-2 pointer" type="checkbox"  v-model="course.restrict_order">

									<label class="mw-80 green">
										<strong>Enable order restriction for modules</strong>
									</label>
									{{ course.restrict_order }}
								</b-col>
							</div>


				            <!-- <div class="row">
				            	<div class="col-12">
				            	
						            <tags :entity_str="'App\\Models\\Course'" 
						            		@tagBlur="updateGroups" ref="tags"></tags>
				            	</div>
				            </div> -->
			            </div><!--col-->
			            <div class="col-lg-4">	
				            <picture-input 
						      ref="pictureInput"
						      accept="image/jpeg,image/png" 
						      size="10" 
						      button-class="button"
						      :custom-strings="{
						        upload: '<h1>Bummer!</h1>',
						        drag: 'Drag or click to upload an image'
						      }"
						      @change="onChange">
						    </picture-input>
			            </div><!--col-->
		            </div><!--row-->


	            </div>
            </div><!--row-->
			<div class="row">
	            <div class="col-auto">
		           <input v-if="!hide_button_submit" type="submit" class="button green-button large-button" value="CONTINUE" @click="submit()"/>
	            	<p class="error" style="color:red"> {{ message_error }}</p>
	            </div><!--col-->
            </div><!--row-->
        </div>
    </div>
	</div>
</template>

<script>
	import PictureInput from 'vue-picture-input';
	export default{
		computed:{
			organization_ids: function(){
				if(this.selected_organization.length != 0){
					let ids = []
					this.selected_organization.map(a=> ids.push(a.id))
					return ids
					
				}else{
					return ''
				}
				return this.selec
			}

		},
		data : function(){
			return {
				tag : '',
				tags : [],
				message_error : '',
				selected : '',
				course : {
					data : {
						title : '',
						description : '',
						image : '',
						notes:'',
						certificate_text:'',
						in_class: 0,
						restrict_order: 0,
					}
				},
				hide_button_submit : false,
				organizations : [],
				selected_organization:[],
				message_selected_organization : '',
			}
		},
		components: {
			PictureInput
		},
		mounted: function(){
			this.getOrganizations()

		},
		methods : {

			submit : function(){

				this.message_error = '';

				this.$validator.validateAll().then((result) => {

					if(result){
						this.hide_button_submit = true;

						var params = this.course.data;
						params.name = params.title;
						params.organization_ids = this.organization_ids;
						params.in_class = params.in_class ? 1 : 0;
						params.restrict_order = this.course.restrict_order ? 1 : 0;
						//params.groups = this.$refs.tags.groups;

						this.$store.dispatch('createCourse', params).then((res) => {
							this.$router.push({ name : 'sme.courses.edit', params : { id : res.data.course.id}});

							this.hide_button_submit = false;
						}).catch((error) => {
							this.hide_button_submit = false;

							this.message_error = 'There was an error while creating the course';
						});
					}else{
						this.message_error = 'Errors detected, check the fields!';
					}
				});			
				
			},
			onChange (image) {
				if (image) {
					this.course.data.image = image;
				}
			},
			updateGroups : function(groups){
				console.log(groups);
			},
			getOrganizations : function() {
				var params = {
					filters : {
						// page : this.current_page,
						// per_page : this.per_page,
						// search: this.search,
						page_loading: false,
						to_select : true
					}
				}
				
				this.$store.dispatch('getOrganizations', params).then((res) => {
					this.organizations = res.data.data;
				}).catch((error) => {
					console.log(error);
				});
			},
		}
	}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/sme/courses/SMECourseCreateComponent.vue